import React from 'react';
import { isDefinedAndNotEmpty } from './Conditional.utils';
import Condition from './components/Condition';
import Default from './components/Default';
import { ChildrenPropType } from '../../types/component';
var propTypes = {
  children: ChildrenPropType.isRequired
};
var defaultProps = {};
export default function Conditional(_ref) {
  var children = _ref.children;
  var defaultChild = null;
  var matchedChild = React.Children.toArray(children).find(function (child) {
    var type = child.type,
      _child$props = child.props,
      props = _child$props === void 0 ? {} : _child$props;
    var condition = props.condition;
    if (type === Condition && isDefinedAndNotEmpty(condition)) {
      return true;
    }
    if (type === Default) {
      defaultChild = child;
    }
    return false;
  });
  return matchedChild || defaultChild;
}
Conditional.propTypes = propTypes;
Conditional.defaultProps = defaultProps;
Conditional.Condition = Condition;
Conditional.Default = Default;